import React from 'react'

const LoadingAnimation = ({ small, light }) => {
  return (
    <div
      className={
        (light ? 'text-light' : 'text-dark') +
        ' spinner-border ' +
        (small ? 'spinner-border-sm' : '')
      }
      role="status"
    >
      <span className="visually-hidden">Loading...</span>
    </div>
  )
}

LoadingAnimation.defaultProps = {
  small: false,
  light: false
}

export default LoadingAnimation
